import { Directive, HostListener, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class SocialShareDirective {
    /**
     * @return {?}
     */
    onMouseEnter() {
        const /** @type {?} */ url = encodeURIComponent(window.location.href);
        switch (this.socialShare) {
            case 'fb':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
                break;
            case 'tw':
                window.open(`https://twitter.com/home?status=${url}`);
                break;
            case 'in':
                window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`);
                break;
            case 'tr':
                window.open(`https://www.tumblr.com/widgets/share/tool?canonicalUrl=${url}`);
                break;
            case 'rd':
                window.open(`https://reddit.com/submit?url=${url}`);
                break;
            case 'pn':
                window.open(`https://www.pinterest.com/pin/find/?url=${url}`);
                break;
            default:
                break;
        }
    }
}
SocialShareDirective.ɵfac = function SocialShareDirective_Factory(t) { return new (t || SocialShareDirective)(); };
SocialShareDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SocialShareDirective, selectors: [["", "socialShare", ""]], hostBindings: function SocialShareDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SocialShareDirective_click_HostBindingHandler() { return ctx.onMouseEnter(); });
    } }, inputs: { socialShare: "socialShare" } });
/** @nocollapse */
SocialShareDirective.propDecorators = {
    "socialShare": [{ type: Input, args: ['socialShare',] },],
    "onMouseEnter": [{ type: HostListener, args: ['click',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SocialShareDirective, [{
        type: Directive,
        args: [{ selector: '[socialShare]' }]
    }], null, { 
    /**
     * @return {?}
     */
    onMouseEnter: [{
            type: HostListener,
            args: ['click']
        }], socialShare: [{
            type: Input,
            args: ['socialShare']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxSocialShareModule {
}
NgxSocialShareModule.ɵfac = function NgxSocialShareModule_Factory(t) { return new (t || NgxSocialShareModule)(); };
NgxSocialShareModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxSocialShareModule });
NgxSocialShareModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSocialShareModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    SocialShareDirective
                ],
                exports: [
                    SocialShareDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSocialShareModule, { declarations: [SocialShareDirective], exports: [SocialShareDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgxSocialShareModule, SocialShareDirective as ɵa };

